import React, { useState, useEffect } from "react";
import {
  Form,
  FormGroup,
  FormInput,
  FormTextarea,
  Button,
  Row,
  Col,
  Container,
  FormFeedback,
} from "shards-react";

import styled from "styled-components";
import { useFormik } from "formik";

import MenuBar from "shared/components/MenuBar/MenuBar";
import ModalLogin from "shared/components/ModalLogin/ModalLogin";
import Layout from "shared/container/LayoutAdmin";
import useToken from "shared/hook/useToken";
import useCurrentUser from "shared/hook/useCurrentUser";
import {
  SelectagencyType,
  SelectAgency,
  SelectTypeUser,
} from "shared/components";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useTranslation } from "react-i18next";
// import getUser  from "shared/utils/getUser";
import baseUrl from "config/baseUrl";

const axios = require("axios").default;

const UserProfilePage = styled.div`
  height: calc(100vh - 240px);
  overflow-y: auto;
  overflow-x: hidden;
`;
const UserProfileFooter = styled.div`
  padding: 30px 0;
  border-top: 1px solid #e0e0e0;
`;
const Link = styled.a`
  color: ${(props) => props.color || "#000"};
  display: block;
  cursor: pointer;
  :hover {
    color: ${(props) => props.color || "#000"};
    text-decoration: none;
  }
`;
const UserProfile = (props) => {
  const { t, i18n } = useTranslation();
  const { location } = props;
  const { token } = useToken();
  const { curruntUser } = useCurrentUser();
  const [openModalLogin, setOpenModalLogin] = useState(false);
  const [changePassword, setChangePassword] = useState(false);
  const [userDetail, setuUerDetail] = useState(null);
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [agencyTypeId, setAgencyTypeId] = useState("");
  const [agencyId, setAgencyId] = useState("");
  const [positionName, setPositionName] = useState("");
  const [agencyType, setAgencyType] = useState("");
  const [agencyName, setAgencyName] = useState("");
  const [purposeAccessingSystem, setPurposeAccessingSystem] = useState("");
  const [userTypeId, setUserTypeId] = useState("");
  const [loading, setLoading] = useState(false);
  const [userId, setUserId] = useState("");

  const showNotify = (message, type) => {
    switch (type) {
      case "success":
        toast.success(message, {
          position: toast.POSITION.TOP_RIGHT,
          autoClose: 3000,
        });
        break;
      case "error":
        toast.error(message, {
          position: toast.POSITION.TOP_RIGHT,
          autoClose: 3000,
        });
        break;
      case "warn":
        toast.warn(message, {
          position: toast.POSITION.TOP_RIGHT,
          autoClose: 3000,
        });
        break;
      case "info":
        toast.info(message, {
          position: toast.POSITION.TOP_RIGHT,
          autoClose: 3000,
        });
        break;
      default:
        toast.success(message, {
          position: toast.POSITION.TOP_RIGHT,
          autoClose: 3000,
        });
    }
  };
  const validate = (values) => {
    const errors = {};
    if (!values.username) {
      errors.username = t("common:logIn.PleaseEnterUsername");
    }
    // if (!values.password) {
    //   errors.password = t("common:logIn.PleaseEnterPassword");
    // }
    // if (!values.confirmpassword) {
    //   errors.confirmpassword = t("common:logIn.PleaseEnterPassword");
    // } else if (values.password !== values.confirmpassword) {
    //   errors.confirmpassword = t("common:resetPassword.PasswordsMatch");
    // }
    if (!values.firstName) {
      errors.firstName = t("common:logIn.PleaseEnterName");
    }
    if (!values.lastName) {
      errors.lastName = t("common:logIn.PleaseEnterSurname");
    }
    if (!values.email) {
      errors.email = t("common:logIn.PleaseEnterEmail");
    } else if (
      !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(values.email)
    ) {
      errors.email = t("common:logIn.InvalidEmailAddress");
    }
    if (!values.phone) {
      errors.phone = t("common:logIn.PleaseEnterTel");
    } else if (values.phone.length < 10) {
      errors.phone = t("common:logIn.PleaseEnterValidNumber");
    }
    if (!values.agencyId) {
      errors.agencyId = t("common:logIn.PleaseEnterAgencyName");
    } else if (values.agencyId === "0") {
      errors.agencyId = t("common:logIn.PleaseEnterAgencyName");
    }

    if (values.agencyId === "32" && !values.agencyName) {
      errors.agencyName = t("common:logIn.PleaseEnterAgencyName");
    }
    // if (!values.positionName) {
    //   errors.positionName = "กรุณาระบุตำแหน่ง";
    // }
    if (!values.agencyTypeId) {
      errors.agencyTypeId = t("common:logIn.PleaseEnterTypeOfAgency");
    } else if (values.agencyTypeId === "0") {
      errors.agencyTypeId = t("common:logIn.PleaseEnterTypeOfAgency");
    }
    // if (!values.purposeAccessingSystem) {
    //   errors.purposeAccessingSystem =t("common:logIn.PleaseEnterPurposeSystem");
    // }

    return errors;
  };
  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      username: username,
      // password: password,
      firstName: firstName,
      lastName: lastName,
      email: email,
      phone: phone,
      agencyTypeId: agencyTypeId,
      agencyId: agencyId,
      positionName: positionName,
      agencyType: agencyType,
      agencyName: agencyName,
      purposeAccessingSystem: purposeAccessingSystem,
    },
    validate,
    onSubmit: (values) => {
      setLoading(true);
      delete values.username
      const sendObject = {
        params: {
          userId: userId,
        },
        update: values,
      };
      var config = {
        method: "post",
        url: `${baseUrl}/v1/user/update`,
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        data: sendObject,
      };
      axios(config)
        .then((response) => {
          setLoading(false);
          showNotify("แจ้งเตือน! บันทึกข้อมูลเรียบร้อย");
        })
        .catch((error) => {
          setLoading(false);
          if(error.response.data.message){
          showNotify(error.response.data.message, "error");
        }else{
          showNotify(error.message, "error");
        }
        });
    },
  });
  const showModalLogin = () => {
    setOpenModalLogin(!openModalLogin);
  };
  useEffect(() => {
    if (token && curruntUser) {
      axios
        .get(`${baseUrl}/v1/user/user?userId=${curruntUser.user.userId}`, {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        })
        .then((response) => {
          setuUerDetail(response.data);
          setUserId(response.data.userId);
          setUsername(response.data.username);
          setPassword(response.data.password);
          setFirstName(response.data.firstName);
          setLastName(response.data.lastName);
          setEmail(response.data.email);
          setPhone(response.data.phone);
          setAgencyTypeId(response.data.agencyTypeId);
          setAgencyId(response.data.agencyId);
          setPositionName(response.data.positionName);
          setAgencyType(response.data.agencyType);
          setAgencyName(response.data.agencyName);
          setUserTypeId(response.data.userType);
          setPurposeAccessingSystem(response.data.purposeAccessingSystem);
        });
    }
  }, [curruntUser, loading]);
  return (
    <>
      <Layout>
        <ToastContainer />
        <Container>
          <MenuBar path={location} title="การจัดการข้อมูลส่วนตัว" />
          <Form onSubmit={formik.handleSubmit}>
            <UserProfilePage>
              <h6 className="bold ">{t("common:logIn.LoginInformation")}</h6>
              <Row>
                <Col md="3">
                  <FormGroup>
                    <label>
                      {t("common:logIn.Username")}<span className="color-red">*</span>
                    </label>
                    <FormInput
                      type="text"
                      name="username"
                      placeholder={t("common:logIn.Username")}
                      onChange={formik.handleChange}
                      invalid={!!formik.errors.username}
                      value={formik.values.username}
                      disabled
                    />
                    {formik.errors.username && (
                      <FormFeedback>{t("common:logIn.PleaseEnterUsername")}</FormFeedback>
                    )}
                  </FormGroup>
                </Col>
                <Col md="3">
                  <FormGroup>
                    <label>{t("common:logIn.Usertype")}</label>
                    <SelectTypeUser
                      placeholder={t("common:logIn.Usertype")}
                      name="userTypeId"
                      onChange={(e) => {
                        setUserTypeId(
                          e.target.value === "0" ? "" : e.target.value
                        );
                      }}
                      defaultValue={userTypeId}
                      value={userTypeId}
                      disabled
                    />
                  </FormGroup>
                </Col>
              </Row>
              <h6 className="bold mt-4">{t("common:logIn.Password")}</h6>
              {changePassword ? (
                <Row>
                  <Col md="4">
                    <FormGroup>
                      <label>
                      {t("common:logIn.OldPassword")}<span className="color-red">*</span>
                      </label>
                      <FormInput
                        type="password"
                        name="oldPassword"
                        placeholder={t("common:logIn.OldPassword")}
                        onChange={formik.handleChange}
                        invalid={!!formik.errors.oldPassword}
                        value={formik.values.oldPassword}
                      />
                      {formik.errors.oldPassword && (
                        <FormFeedback>{formik.errors.oldPassword}</FormFeedback>
                      )}
                    </FormGroup>
                  </Col>
                  <Col md="4">
                    <FormGroup>
                      <label>
                      {t("common:logIn.NewPassword")}<span className="color-red">*</span>
                      </label>
                      <FormInput
                        type="password"
                        name="password"
                        placeholder={t("common:logIn.NewPassword")}
                        onChange={formik.handleChange}
                        invalid={!!formik.errors.password}
                        value={formik.values.password}
                      />
                      {formik.errors.password && (
                        <FormFeedback>{formik.errors.password}</FormFeedback>
                      )}
                    </FormGroup>
                  </Col>
                  <Col md="4">
                    <FormGroup>
                      <label>
                      {t("common:logIn.ConfirmPassword")}
                        <span className="color-red">*</span>
                      </label>
                      <FormInput
                        type="password"
                        name="confirmpassword"
                        placeholder={t("common:logIn.ConfirmPassword")}
                        onChange={formik.handleChange}
                        invalid={!!formik.errors.confirmpassword}
                        value={formik.values.confirmpassword}
                      />
                      {formik.errors.confirmpassword && (
                        <FormFeedback>
                          {formik.errors.confirmpassword}
                        </FormFeedback>
                      )}
                    </FormGroup>
                  </Col>
                </Row>
              ) : (
                <Link
                  className="mb-5 mt-5"
                  color="#1968BC"
                  onClick={showModalLogin}
                >
                  {t("common:logIn.ChangeNewPassword")}
                </Link>
              )}

              <h6 className="bold  mt-4"> {t("common:logIn.PersonalInformation")}</h6>
              <Row>
                <Col md="3">
                  <FormGroup>
                    <label>
                    {t("common:logIn.Name")}<span className="color-red">*</span>
                    </label>
                    <FormInput
                      type="text"
                      placeholder={t("common:logIn.Name")}
                      name="firstName"
                      onChange={formik.handleChange}
                      invalid={!!formik.errors.firstName}
                      value={formik.values.firstName}
                    />
                    {formik.errors.firstName && (
                      <FormFeedback>{formik.errors.firstName}</FormFeedback>
                    )}
                  </FormGroup>
                </Col>
                <Col md="3">
                  <FormGroup>
                    <label>
                    {t("common:logIn.Surname")}<span className="color-red">*</span>
                    </label>
                    <FormInput
                      type="text"
                      placeholder={t("common:logIn.Surname")}
                      name="lastName"
                      onChange={formik.handleChange}
                      invalid={!!formik.errors.lastName}
                      value={formik.values.lastName}
                    />
                    {formik.errors.lastName && (
                      <FormFeedback>{formik.errors.lastName}</FormFeedback>
                    )}
                  </FormGroup>
                </Col>
                <Col md="3">
                  <FormGroup>
                    <label htmlFor="#phone">
                    {t("common:logIn.Tel")}<span className="color-red">*</span>
                    </label>
                    <FormInput
                      type="tel"
                      name="phone"
                      placeholder={t("common:logIn.Tel")}
                      onChange={formik.handleChange}
                      invalid={!!formik.errors.phone}
                      value={formik.values.phone}
                    />
                    {formik.errors.phone && (
                      <FormFeedback>{formik.errors.phone}</FormFeedback>
                    )}
                  </FormGroup>
                </Col>
              </Row>
              <Row>
                <Col md="3">
                  <FormGroup>
                    <label htmlFor="#email">
                    {t("common:logIn.Email")}<span className="color-red">*</span>
                    </label>
                    <FormInput
                      type="email"
                      name="email"
                      placeholder={t("common:logIn.Email")}
                      onChange={formik.handleChange}
                      invalid={!!formik.errors.email}
                      value={formik.values.email}
                    />
                    {formik.errors.email && (
                      <FormFeedback>{formik.errors.email}</FormFeedback>
                    )}
                  </FormGroup>
                </Col>
              </Row>
              <Row>
                <Col md="3">
                  <FormGroup>
                    <label>
                    {t("common:logIn.TypeOfAgency")}<span className="color-red">*</span>
                    </label>
                    <SelectagencyType
                      placeholder="เลือก"
                      name="agencyTypeId"
                      onChange={(e) => {
                        const id = e.nativeEvent.target.selectedIndex;
                        if(id !== "1" && id !== "0" && id !== 1 && id !== 0){
                          setAgencyId("32");
                        }
                        setAgencyTypeId(e.target.value);
                        setAgencyName("");
                        setAgencyType(e.nativeEvent.target[id].text);
                        // formik.handleChange(e);
                      }}
                      value={formik.values.agencyTypeId}
                      invalid={!!formik.errors.agencyTypeId}
                      // onBlur={formik.handleBlur}
                    />
                    {formik.errors.agencyTypeId && (
                      <FormFeedback>{formik.errors.agencyTypeId}</FormFeedback>
                    )}
                  </FormGroup>
                </Col>
                <Col md="3">
                  <FormGroup>
                    <label>
                    {t("common:logIn.AgencyName")}<span className="color-red">*</span>
                    </label>
                    <SelectAgency
                      placeholder="เลือก"
                      name="agencyId"
                      onChange={(e) => {
                        const id = e.nativeEvent.target.selectedIndex;
                        setAgencyId(e.target.value);
                        if (e.target.value === "32") {
                          setAgencyName("");
                        } else {
                          setAgencyName(e.nativeEvent.target[id].text);
                        }
                        // formik.handleChange(e);
                      }}
                      defaultValue={agencyId}
                      value={formik.values.agencyId}
                      invalid={!!formik.errors.agencyId}
                      typeId={formik.values.agencyTypeId}
                      disabled={agencyTypeId && (agencyTypeId !== "1" && agencyTypeId !== 1 && agencyTypeId !== "0" && agencyTypeId !== 0)}
                      // onBlur={formik.handleBlur}
                    />
                    {formik.errors.agencyId && (
                      <FormFeedback>{formik.errors.agencyId}</FormFeedback>
                    )}
                  </FormGroup>
                </Col>
                {(agencyId === "32" || agencyId === 32 )&& (
                  <Col md="3">
                    <FormGroup>
                      <label>ชื่อหน่วยงาน<span className="color-red">*</span></label>
                      <FormInput
                        type="text"
                        placeholder="โปรดระบุ"
                        onChange={formik.handleChange}
                        name="agencyName"
                        invalid={!!formik.errors.agencyName}
                        value={formik.values.agencyName}
                      />
                      {formik.errors.agencyName && (
                        <FormFeedback>{formik.errors.agencyName}</FormFeedback>
                      )}
                    </FormGroup>
                  </Col>
                )}
                <Col md="3">
                  <FormGroup>
                    <label>{t("common:logIn.PositionProfession")}</label>
                    <FormInput
                      type="text"
                      placeholder={t("common:logIn.PositionProfession")}
                      onChange={formik.handleChange}
                      name="positionName"
                      invalid={!!formik.errors.positionName}
                      value={formik.values.positionName}
                    />
                    {formik.errors.positionName && (
                      <FormFeedback>{formik.errors.positionName}</FormFeedback>
                    )}
                  </FormGroup>
                </Col>
              </Row>
              <Row>
                <Col md="6">
                  <FormGroup>
                    <label>
                    {t("common:logIn.PurposeSystem")}
                      {/* <span className="color-red">*</span> */}
                    </label>
                    <FormTextarea
                      name="purposeAccessingSystem"
                      onChange={formik.handleChange}
                      value={formik.values.purposeAccessingSystem}
                      invalid={!!formik.errors.purposeAccessingSystem}
                      placeholder={t("common:logIn.PurposeSystem")}
                    />

                    {formik.errors.purposeAccessingSystem && (
                      <FormFeedback>
                        {formik.errors.purposeAccessingSystem}
                      </FormFeedback>
                    )}
                  </FormGroup>
                </Col>
              </Row>
            </UserProfilePage>
            <UserProfileFooter>
              <Row>
                <Col md="6"></Col>
                <Col md="3">
                  <Button
                    className="btn btn-white w-100"
                    onClick={() => (window.location = "/")}
                  >
                    {t("common:logIn.Back")}
                  </Button>
                </Col>
                <Col md="3">
                  <Button type="submit" className="btn btn-success w-100">
                  {t("common:logIn.Save")}
                  </Button>
                </Col>
              </Row>
            </UserProfileFooter>
          </Form>
        </Container>

        {openModalLogin && (
          <ModalLogin
            visible={openModalLogin}
            onCancel={showModalLogin}
            statusModal={3}
          />
        )}
      </Layout>
    </>
  );
};

export default UserProfile;
